import { extend } from 'vee-validate';
import VideoViewingService from '@/services/VideoViewingService';

extend('video_viewing_id_unique', {
  validate: (id) => {
    return VideoViewingService.validateId(id)
      .then((response) => {
        return {
          valid: response.data.isValid,
        };
      })
      .catch(() => {
        return {
          valid: false,
        };
      });
  },
});
